<template>
    <tr class="table-tr" @click="onRowClicked">
        <slot></slot>
    </tr>
</template>

<script>
export default {
    name: "TagTableRow",
    methods: {
        onRowClicked() {
            this.$emit('click-row')
        }
    },
}
</script>

<style scoped>
.table-tr:hover{
    background: #ddd;
}
</style>